<template>

  <div>

    <!-- Encabezado -->

    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">

      <div>

        <div class="flex items-center gap-2 text-sm text-slate-500 mb-1">

          <router-link to="/admin/sistemas" class="hover:text-emerald-600 transition-colors">Sistemas</router-link>

          <i class="fa-solid fa-chevron-right text-xs"></i>

          <span class="text-slate-700 font-medium">Planes</span>

          <span v-if="nombreSistema" class="text-emerald-600 font-semibold">· {{ nombreSistema }}</span>

        </div>

        <h2 class="text-2xl font-bold text-slate-800">Planes</h2>

        <p class="text-slate-500 text-sm mt-1">Gestiona los paquetes y precios de cada sistema.</p>

      </div>

      <div class="flex flex-wrap gap-3 self-start sm:self-auto">

        <select

          v-model="filtroSistema"

          @change="cargar"

          class="border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-400 bg-white"

        >

          <option :value="0">Todos los sistemas</option>

          <option v-for="s in sistemas" :key="s.idSistema" :value="s.idSistema">

            {{ s.icono }} {{ s.nombre }}

          </option>

        </select>

        <button

          @click="abrirNuevo"

          class="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2.5 rounded-xl font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105"

        >

          <i class="fa-solid fa-plus"></i>

          Nuevo Plan

        </button>

      </div>

    </div>



    <!-- Tabla -->

    <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">

      <div class="overflow-x-auto">

        <table class="w-full text-sm">

          <thead>

            <tr class="bg-slate-50 border-b border-slate-200">

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">#</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Sistema</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Plan</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Descripción</th>

              <th class="px-6 py-4 text-right text-xs font-semibold text-slate-500 uppercase tracking-wider">Precio/mes</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Estatus</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Acciones</th>

            </tr>

          </thead>

          <tbody class="divide-y divide-slate-100">

            <tr v-if="cargando">

              <td colspan="7" class="px-6 py-12 text-center text-slate-400">

                <i class="fa-solid fa-spinner fa-spin text-2xl text-emerald-400 mr-2"></i>Cargando...

              </td>

            </tr>

            <tr v-else-if="planes.length === 0">

              <td colspan="7" class="px-6 py-12 text-center text-slate-400">

                <i class="fa-solid fa-inbox text-3xl mb-2 block"></i>No hay planes registrados

              </td>

            </tr>

            <tr

              v-else

              v-for="(item, idx) in planes"

              :key="item.idPlan"

              class="hover:bg-slate-50 transition-colors duration-150"

            >

              <td class="px-6 py-4 text-slate-400 text-xs">{{ idx + 1 }}</td>

              <td class="px-6 py-4">

                <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700">

                  {{ item.nombreSistema }}

                </span>

              </td>

              <td class="px-6 py-4 font-semibold text-slate-800">{{ item.nombrePlan }}</td>

              <td class="px-6 py-4 text-slate-500 max-w-xs truncate">{{ item.descripcion }}</td>

              <td class="px-6 py-4 text-right">

                <span class="font-bold text-emerald-600 text-base">${{ formatPrecio(item.precio) }}</span>

                <span class="text-slate-400 text-xs"> /mes</span>

              </td>

              <td class="px-6 py-4">

                <span :class="['inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold',

                               item.estatus === 'A' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600']">

                  <span :class="['w-1.5 h-1.5 rounded-full', item.estatus === 'A' ? 'bg-emerald-500' : 'bg-red-500']"></span>

                  {{ item.estatus === 'A' ? 'Activo' : 'Inactivo' }}

                </span>

              </td>

              <td class="px-6 py-4">

                <div class="flex items-center gap-2">

                  <button

                    @click="editar(item)"

                    class="p-2 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-600 transition-colors duration-150"

                    title="Editar"

                  ><i class="fa-solid fa-pen-to-square text-xs"></i></button>

                  <button

                    @click="verCaracteristicas(item)"

                    class="p-2 rounded-lg bg-green-50 hover:bg-green-100 text-green-600 transition-colors duration-150"

                    title="Características"

                  ><i class="fa-solid fa-list-check text-xs"></i></button>

                  <button

                    @click="cambiarEstatus(item)"

                    :class="['p-2 rounded-lg transition-colors duration-150',

                             item.estatus === 'A' ? 'bg-red-50 hover:bg-red-100 text-red-500' : 'bg-emerald-50 hover:bg-emerald-100 text-emerald-600']"

                    :title="item.estatus === 'A' ? 'Desactivar' : 'Activar'"

                  ><i :class="['text-xs', item.estatus === 'A' ? 'fa-solid fa-ban' : 'fa-solid fa-check']"></i></button>

                </div>

              </td>

            </tr>

          </tbody>

        </table>

      </div>

    </div>



    <!-- Modal -->

    <transition name="modal">

      <div v-if="modalVisible" class="fixed inset-0 z-50 flex items-center justify-center modal-overlay p-4">

        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-lg">

          <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100">

            <h3 class="font-bold text-slate-800 text-lg">

              <i class="fa-solid fa-box-open text-emerald-500 mr-2"></i>

              {{ modoEdicion ? 'Editar Plan' : 'Nuevo Plan' }}

            </h3>

            <button @click="cerrarModal" class="text-slate-400 hover:text-slate-600 p-1">

              <i class="fa-solid fa-xmark text-lg"></i>

            </button>

          </div>



          <div class="px-6 py-5 space-y-4">

            <div>

              <label class="block text-sm font-semibold text-slate-700 mb-1">Sistema <span class="text-red-500">*</span></label>

              <select

                v-model="form.idSistema"

                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 bg-white"

              >

                <option :value="0" disabled>-- Selecciona un sistema --</option>

                <option v-for="s in sistemas" :key="s.idSistema" :value="s.idSistema">

                  {{ s.icono }} {{ s.nombre }}

                </option>

              </select>

            </div>



            <div>

              <label class="block text-sm font-semibold text-slate-700 mb-1">Nombre del Plan <span class="text-red-500">*</span></label>

              <input

                v-model="form.nombrePlan"

                type="text"

                maxlength="100"

                placeholder="Ej. Básico, Estándar, Premium"

                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"

              />

            </div>



            <div>

              <label class="block text-sm font-semibold text-slate-700 mb-1">Descripción</label>

              <textarea

                v-model="form.descripcion"

                rows="3"

                maxlength="500"

                placeholder="Descripción del plan..."

                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent resize-none transition-all"

              ></textarea>

            </div>



            <div>

              <label class="block text-sm font-semibold text-slate-700 mb-1">Precio mensual (MXN) <span class="text-red-500">*</span></label>

              <div class="relative">

                <span class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 font-semibold">$</span>

                <input

                  v-model.number="form.precio"

                  type="number"

                  min="0"

                  step="0.01"

                  placeholder="0.00"

                  class="w-full border border-slate-300 rounded-xl pl-8 pr-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"

                />

              </div>

            </div>

          </div>



          <div class="flex justify-end gap-3 px-6 py-4 border-t border-slate-100">

            <button

              @click="cerrarModal"

              class="px-5 py-2.5 rounded-xl border border-slate-300 text-slate-600 font-semibold text-sm hover:bg-slate-50 transition-all"

            >Cancelar</button>

            <button

              @click="guardar"

              :disabled="guardando"

              class="px-5 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105 disabled:opacity-60 disabled:cursor-not-allowed"

            >

              <i v-if="guardando" class="fa-solid fa-spinner fa-spin mr-1"></i>

              {{ guardando ? 'Guardando...' : 'Guardar' }}

            </button>

          </div>

        </div>

      </div>

    </transition>

  </div>

</template>



<script>

import servicioPlan    from '@/services/planes.service'

import servicioSistema from '@/services/sistemas.service'



export default {

  name: 'PlanesAdmin',

  props: {

    idSistema: { default: null }

  },

  data () {

    return {

      planes:         [],

      sistemas:       [],

      filtroSistema:  0,

      nombreSistema:  '',

      cargando:       false,

      guardando:      false,

      modalVisible:   false,

      modoEdicion:    false,

      form: {

        idPlan:      0,

        idSistema:   0,

        nombrePlan:  '',

        descripcion: '',

        precio:      0

      }

    }

  },

  mounted () {

    if (this.idSistema) {

      this.filtroSistema = parseInt(this.idSistema)

    }

    this.cargarSistemas()

    this.cargar()

  },

  methods: {

    formatPrecio (valor) {

      return Number(valor).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

    },



    async cargarSistemas () {

      try {

        const res = await servicioSistema.sistemasCon()

        this.sistemas = (res.data.sistemas || []).filter(s => s.estatus === 'A')

        if (this.filtroSistema) {

          const sis = this.sistemas.find(s => s.idSistema === this.filtroSistema)

          this.nombreSistema = sis ? sis.nombre : ''

        }

      } catch { /* silencioso */ }

    },



    async cargar () {

      this.cargando = true

      try {

        const res = await servicioPlan.planesCon(this.filtroSistema)

        this.planes = res.data.planes || []

      } catch {

        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cargar planes', tipo: 'error' })

      } finally {

        this.cargando = false

      }

    },



    abrirNuevo () {

      this.modoEdicion      = false

      this.form.idPlan      = 0

      this.form.idSistema   = this.filtroSistema || 0

      this.form.nombrePlan  = ''

      this.form.descripcion = ''

      this.form.precio      = 0

      this.modalVisible     = true

    },



    editar (item) {

      this.modoEdicion      = true

      this.form.idPlan      = item.idPlan

      this.form.idSistema   = item.idSistema

      this.form.nombrePlan  = item.nombrePlan

      this.form.descripcion = item.descripcion

      this.form.precio      = item.precio

      this.modalVisible     = true

    },



    cerrarModal () { this.modalVisible = false },



    async guardar () {

      if (!this.form.nombrePlan.trim() || !this.form.idSistema) {

        this.$store.dispatch('mostrarToast', { mensaje: 'El sistema y nombre del plan son obligatorios', tipo: 'warning' })

        return

      }

      this.guardando = true

      try {

        const res = await servicioPlan.guardar(this.form)

        if (res.data.resultado) {

          this.cerrarModal()

          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })

          await this.cargar()

        } else {

          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'warning' })

        }

      } catch {

        this.$store.dispatch('mostrarToast', { mensaje: 'Error al guardar el plan', tipo: 'error' })

      } finally {

        this.guardando = false

      }

    },



    async cambiarEstatus (item) {

      const nuevoEstatus = item.estatus === 'A' ? 'I' : 'A'

      try {

        const res = await servicioPlan.cambiarEstatus({ idPlan: item.idPlan, estatus: nuevoEstatus })

        if (res.data.resultado) {

          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })

          await this.cargar()

        }

      } catch {

        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cambiar estatus', tipo: 'error' })

      }

    },



    verCaracteristicas (item) {

      this.$router.push({ name: 'AdminCaracteristicas', params: { idPlan: item.idPlan } })

    }

  }

}

</script>



